import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

const isDev = process.env.NODE_ENV === 'development';
const store = isDev
  ? createStore(reducer, composeWithDevTools(applyMiddleware(thunk)))
  : createStore(reducer, applyMiddleware(thunk));

export default store;
